import { IsBoolean, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CareerId } from '../../const/catalog/career';
import { ClientType } from '../client/clientType';
import type { FilterableValue } from '../filterable';
import { DealProcessingStatus } from './const';

export enum ProcessingCountersType {
  Negotiation = 1,
  Accepted = 2,
  RejectedByClient = 3,
  RejectedByExpired = 4,
  InProgress = 5,
  Completed = 6,
}

export class ProcessingCountersRequest {
  @ApiProperty()
  @IsOptional()
  type?: FilterableValue<ClientType>;

  @ApiProperty()
  @IsOptional()
  cityId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  careerId?: FilterableValue<CareerId>;

  @ApiProperty()
  @IsOptional()
  phoneOrEmail?: FilterableValue<string>;

  @ApiProperty()
  @IsOptional()
  vacancyId?: FilterableValue<number>;
}

export class ProcessingCounterViewModel {
  @ApiProperty()
  @IsNumber()
  count: number;

  @ApiProperty()
  @IsNumber()
  status?: DealProcessingStatus;
}

export class ProcessingCountersResponse {
  @ApiProperty({
    example: {
      [ProcessingCountersType.Accepted]: {
        count: 1,
        status: DealProcessingStatus.Waiting,
      },
    },
  })
  counters: Record<ProcessingCountersType, ProcessingCounterViewModel>;
}
